"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CubeModel = _interopRequireDefault(require("../Models/CubeModel"));
var _models = require("../../models");
var _constants = require("../../../utils/constants");
const _excluded = ["thingPwhSupplyDeviceTypeKey", "hasCirculation", "hasPwhC", "isFirst", "isLast", "isSerial"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const ItemPipes = props => {
  const {
      thingPwhSupplyDeviceTypeKey: pwhSupTypeKey = null,
      hasCirculation = false,
      hasPwhC = false,
      isFirst = false,
      isLast = false,
      isSerial = false
    } = props,
    p = _objectWithoutProperties(props, _excluded);
  const isKey = (0, _react.useCallback)(key => Number(pwhSupTypeKey) === key, [pwhSupTypeKey]);
  return /*#__PURE__*/_react.default.createElement("group", p, /*#__PURE__*/_react.default.createElement("group", null, /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    visible: isSerial ? isLast : true,
    position: [0, 10, 0],
    args: [1, 1, 0.5],
    highlightsType: _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    visible: !isSerial,
    position: [0, 10, 0],
    scale: [1, 1, 5.2],
    rotation: [0, 0, 0],
    highlightsType: _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 10, -25.5],
    scale: [1, 1, 1.5],
    rotation: [0, 0, 0],
    visible: isSerial ? isFirst : true,
    highlightsType: isKey(_constants.pwhSupConfig.hotWater) ? _constants.pipesTypes.heatingReturn : _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 10, -37],
    scale: [1, 1, 1.6],
    rotation: [0, 0, 0],
    visible: isSerial ? isFirst : true,
    highlightsType: isKey(_constants.pwhSupConfig.storeCharging) ? _constants.pipesTypes.chilledWater : _constants.pipesTypes.heatingReturn
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    visible: isSerial && isFirst,
    position: [0, 10, -10],
    scale: [1, 1, 2],
    rotation: [0, 0, 0],
    highlightsType: _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    visible: isSerial && isLast,
    position: [0, 10, 0],
    scale: [1, 1, 1.58],
    rotation: [0, 0, 0],
    highlightsType: _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [isLast ? 1 : 0, 10, isLast ? -9 : -10],
    rotation: [0, isLast ? Math.PI / 2 : Math.PI, 0],
    visible: isSerial && (isFirst || isLast),
    highlightsType: _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [1, 10, -9],
    scale: [1, 1, 1.58],
    rotation: [0, -Math.PI / 2, 0],
    visible: isSerial && (isFirst || isLast),
    highlightsType: _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [9, 10, -9],
    args: [0.5, 1, 1],
    highlightsType: _constants.pipesTypes.chilledWater,
    visible: isSerial && (isFirst || isLast)
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [9.5 + _constants.spaseBetweenModels, 10, -9],
    args: [0.5, 1, 1],
    highlightsType: _constants.pipesTypes.chilledWater,
    visible: isSerial && (isFirst || isLast)
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [9.7 + _constants.spaseBetweenModels, 10, -9],
    scale: [1, 1, 1.86],
    rotation: [0, -Math.PI / 2, 0],
    visible: isSerial && (isFirst || isLast),
    highlightsType: _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [(isLast ? 19 : 20) + _constants.spaseBetweenModels, 10, isLast ? -9 : -8],
    rotation: [0, isLast ? -Math.PI / 2 : 0, 0],
    visible: isSerial && (isFirst || isLast),
    highlightsType: _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    visible: isSerial && isLast,
    position: [20 + _constants.spaseBetweenModels, 10, -10.1],
    scale: [1, 1, 7],
    rotation: [0, 0, 0],
    highlightsType: _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [20 + _constants.spaseBetweenModels, 10, -45],
    args: [1, 1, 0.5],
    highlightsType: _constants.pipesTypes.chilledWater,
    visible: isSerial && isLast
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    visible: isSerial && isFirst,
    position: [20 + _constants.spaseBetweenModels, 10, -0.1],
    scale: [1, 1, 1.58],
    rotation: [0, 0, 0],
    highlightsType: _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [20 + _constants.spaseBetweenModels, 10, 0],
    args: [1, 1, 0.5],
    highlightsType: _constants.pipesTypes.chilledWater,
    visible: isSerial && !isLast
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    visible: isSerial && !isFirst && !isLast,
    position: [20 + _constants.spaseBetweenModels, 10, -0.1],
    scale: [1, 1, 9],
    rotation: [0, 0, 0],
    highlightsType: _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [20 + _constants.spaseBetweenModels, 10, -45],
    args: [1, 1, 0.5],
    highlightsType: _constants.pipesTypes.chilledWater,
    visible: isSerial && !isFirst && !isLast
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    visible: isSerial ? isFirst : true,
    position: [0, 10, -45],
    args: [1, 1, 0.5],
    highlightsType: isKey(_constants.pwhSupConfig.storeCharging) ? _constants.pipesTypes.chilledWater : _constants.pipesTypes.heatingReturn
  })), /*#__PURE__*/_react.default.createElement("group", null, /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    visible: hasPwhC,
    position: [0, 20, 0],
    args: [1, 1, 0.5],
    highlightsType: _constants.pipesTypes.circulation
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 20, 0],
    scale: [1, 1, 4.5],
    rotation: [0, 0, 0],
    visible: hasCirculation && hasPwhC,
    highlightsType: _constants.pipesTypes.circulation
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 20, -29],
    scale: [1, 1, 0.8],
    rotation: [0, 0, 0],
    highlightsType: isKey(_constants.pwhSupConfig.hotWater) ? isSerial && !isFirst ? _constants.pipesTypes.hotWater : _constants.pipesTypes.heatingFlow : _constants.pipesTypes.hotWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 20, -37],
    scale: [1, 1, 1.6],
    rotation: [0, 0, 0],
    highlightsType: isKey(_constants.pwhSupConfig.storeCharging) ? _constants.pipesTypes.hotWater : isSerial && !isFirst ? _constants.pipesTypes.hotWater : _constants.pipesTypes.heatingFlow
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, 20, -45],
    args: [1, 1, 0.5],
    highlightsType: isKey(_constants.pwhSupConfig.storeCharging) ? _constants.pipesTypes.hotWater : isSerial && !isFirst ? _constants.pipesTypes.hotWater : _constants.pipesTypes.heatingFlow
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 18.9, -23],
    scale: [1, 1, 1.78],
    rotation: [-Math.PI / 2, 0, 0],
    visible: hasCirculation && hasPwhC,
    highlightsType: _constants.pipesTypes.circulation
  }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [0, 20, -22],
    rotation: [0, 0, Math.PI / 2],
    visible: hasCirculation && hasPwhC,
    highlightsType: _constants.pipesTypes.circulation
  })), /*#__PURE__*/_react.default.createElement("group", null, /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, hasCirculation ? 30 : 20, 0],
    args: [1, 1, 0.5],
    highlightsType: _constants.pipesTypes.hotWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, hasCirculation ? 30 : 20, 0],
    scale: [1, 1, hasCirculation ? 5.4 : 5.8],
    rotation: [0, 0, 0],
    highlightsType: _constants.pipesTypes.hotWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 29, -28],
    scale: [1, 1, 1.6],
    rotation: [-Math.PI / 2, 0, 0],
    visible: hasCirculation && hasPwhC,
    highlightsType: _constants.pipesTypes.hotWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [0, 30, -27],
    rotation: [0, 0, Math.PI / 2],
    visible: hasCirculation && hasPwhC,
    highlightsType: _constants.pipesTypes.hotWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [0, 20, -29],
    rotation: [0, -Math.PI, -Math.PI / 2],
    visible: hasCirculation && hasPwhC,
    highlightsType: _constants.pipesTypes.hotWater
  })));
};
var _default = exports.default = ItemPipes;